function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from "react";
import { Menu } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Common from "../includes/Common";
import { Power, HouseFill, FolderFill, BuildingFillGear, ImageFill, ShareFill, Broadcast, CollectionFill, Eyedropper, BookmarksFill, PersonBoundingBox, MagnetFill, FileBreak, CashStack, BoxSeamFill, ClipboardHeartFill, Speedometer, Clipboard2PulseFill, Building, PeopleFill, GearFill, EyeFill, Tools, Capsule, SlashSquareFill } from 'react-bootstrap-icons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SubMenu = Menu.SubMenu;
var UserNavBar = function UserNavBar(_ref) {
  var handleMenuClose = _ref.handleMenuClose;
  var navigate = useNavigate();
  var _useState = useState('day'),
    _useState2 = _slicedToArray(_useState, 2),
    current = _useState2[0],
    setCurrent = _useState2[1];
  var handleClick = function handleClick(e) {
    setCurrent(e.key);
    if (e.key == 'quit') {
      axios.post(Common.baseApiUrl + 'sulogout').then(function (response) {
        if (response.data.status == 200) {
          localStorage.clear();
          navigate('/');
        }
      })["catch"](function (error) {});
    }
    handleMenuClose();
  };
  var user = Common.currentUser;
  return /*#__PURE__*/_jsxs(Menu, {
    onClick: handleClick,
    style: {
      background: "#2F546F"
    },
    selectedKeys: current,
    theme: "dark",
    mode: "vertical",
    children: [(Common.currentUser.role == 91 || Common.currentUser.role == 51) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Speedometer, {
        size: 18
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/dashboard",
        children: /*#__PURE__*/_jsx("b", {
          children: "Tab. de bord"
        })
      })
    }, "dash"), (Common.currentUser.role == 91 || Common.currentUser.role == 11 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(HouseFill, {
        size: 18
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/cashier",
        children: /*#__PURE__*/_jsx("b", {
          children: "Accueil"
        })
      })
    }, "day"), (Common.currentUser.role == 91 || Common.currentUser.role == 71) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Eyedropper, {
        size: 18
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/laboratoire",
        children: /*#__PURE__*/_jsx("b", {
          children: "Laboratoire"
        })
      })
    }, "lab"), (Common.currentUser.role == 91 || Common.currentUser.role == 31 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Clipboard2PulseFill, {
        size: 18
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/consultations",
        children: /*#__PURE__*/_jsx("b", {
          children: "Consultation"
        })
      })
    }, "cons"), (Common.currentUser.role == 91 || Common.currentUser.role == 61) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(ImageFill, {
        size: 18
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: "Imagerie"
      }),
      children: [(Common.currentUser.role == 91 || Common.currentUser.role == 21 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(ImageFill, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/echographie",
          children: /*#__PURE__*/_jsx("b", {
            children: "Echographie"
          })
        })
      }, "echo"), (Common.currentUser.role == 91 || Common.currentUser.role == 21 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Broadcast, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/radiologie",
          children: /*#__PURE__*/_jsx("b", {
            children: "Radiographie"
          })
        })
      }, "radio"), (Common.currentUser.role == 91 || Common.currentUser.role == 21 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(FileBreak, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/scanner",
          children: /*#__PURE__*/_jsx("b", {
            children: "Scanner"
          })
        })
      }, "scan"), (Common.currentUser.role == 91 || Common.currentUser.role == 21 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(MagnetFill, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/irm",
          children: /*#__PURE__*/_jsx("b", {
            children: "IRM"
          })
        })
      }, "irm"), (Common.currentUser.role == 91 || Common.currentUser.role == 21 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(PersonBoundingBox, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/mammographie",
          children: /*#__PURE__*/_jsx("b", {
            children: "Mammographie"
          })
        })
      }, "mammo")]
    }, "exp"), (Common.currentUser.role == 91 || Common.currentUser.role == 11 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(CollectionFill, {
        size: 18
      }),
      children: /*#__PURE__*/_jsx(Link, {
        className: "menu_l",
        to: "/home/attendance",
        children: /*#__PURE__*/_jsx("b", {
          children: "Flux amb."
        })
      })
    }, "freq"), (Common.currentUser.role == 91 || Common.currentUser.role == 51) && /*#__PURE__*/_jsxs(SubMenu, {
      icon: /*#__PURE__*/_jsx(BuildingFillGear, {
        size: 18
      }),
      title: /*#__PURE__*/_jsx("b", {
        children: "Administration"
      }),
      children: [(Common.currentUser.role == 91 || Common.currentUser.role == 61 || Common.currentUser.role == 31 || Common.currentUser.role == 41) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(BoxSeamFill, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/consumables",
          children: /*#__PURE__*/_jsx("b", {
            children: "Consommables"
          })
        })
      }, "cons"), (Common.currentUser.role == 91 || Common.currentUser.role == 31 || Common.currentUser.role == 41 || Common.currentUser.role == 11 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(PeopleFill, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          to: "/home/hr",
          children: /*#__PURE__*/_jsx("b", {
            children: "Res. Humaines"
          })
        })
      }, "rh"), (Common.currentUser.role == 91 || Common.currentUser.role == 31 || Common.currentUser.role == 41 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(CashStack, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/facturation",
          children: /*#__PURE__*/_jsx("b", {
            children: "Comptabilit\xE9"
          })
        })
      }, "fact"), (Common.currentUser.role == 91 || Common.currentUser.role == 31 || Common.currentUser.role == 41) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(Building, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/companies",
          children: /*#__PURE__*/_jsx("b", {
            children: "Soci\xE9t\xE9s"
          })
        })
      }, "comps"), (Common.currentUser.role == 91 || Common.currentUser.role == 31 || Common.currentUser.role == 41 || Common.currentUser.role == 61) && /*#__PURE__*/_jsx(Menu.Item, {
        icon: /*#__PURE__*/_jsx(FolderFill, {
          size: 18
        }),
        children: /*#__PURE__*/_jsx(Link, {
          className: "menu_l",
          to: "/home/departments",
          children: /*#__PURE__*/_jsx("b", {
            children: "Articles"
          })
        })
      }, "Depts")]
    }, "adm"), Common.currentUser.role == 91 && /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(PeopleFill, {
        style: {
          color: 'FBB91D'
        },
        size: 18
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/users",
        children: /*#__PURE__*/_jsx("b", {
          children: "Utilisateurs"
        })
      })
    }, "users"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(GearFill, {
        style: {
          color: 'FBB91D'
        },
        size: 18
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "/home/accountconfig",
        children: /*#__PURE__*/_jsx("b", {
          children: "Mon compte"
        })
      })
    }, "accountconfig"), /*#__PURE__*/_jsx(Menu.Item, {
      icon: /*#__PURE__*/_jsx(Power, {
        style: {
          color: 'EA696B',
          fontWeight: "bold"
        },
        size: 22
      }),
      children: /*#__PURE__*/_jsx(Link, {
        to: "#",
        children: /*#__PURE__*/_jsx("b", {
          children: "D\xE9connexion"
        })
      })
    }, "quit")]
  });
};
export default UserNavBar;